module.exports = __webpack_public_path__ + "static/media/leslie.ded75d1b.jpg";